import { SelectionData } from '../../models/util.model'
import { PermissionsScope } from '../policies/policy.model'
import { WarehouseAreaSettings, WarehouseTab } from './warehouse.model'

export const WAREHOUSE_FRAGMENT = 'warehouse'
export const WAREHOUSE_PATH = 'warehouses'
export const WAREHOUSE_SCOPE: PermissionsScope = 'locations'

export const WAREHOUSE_TABS: SelectionData<WarehouseTab>[] = [
  {
    value: WarehouseTab.structure,
    label: 'Struttura',
  },
  {
    value: WarehouseTab.logistic,
    label: 'Logistica',
  },
]

export const WAREHOUSE_AREA_LEVELS: string[] = [
  'Corsia',
  'Scaffale',
  'Livello',
  'Posizione',
  'Scomparto',
]

type AreaLevelKey = keyof Pick<
  WarehouseAreaSettings,
  'aisles' | 'racks' | 'shelves' | 'positions' | 'compartments'
>
export const AREA_LEVEL_KEYS: Record<string, AreaLevelKey> = {
  Corsia: 'aisles',
  Scaffale: 'racks',
  Livello: 'shelves',
  Posizione: 'positions',
  Scomparto: 'compartments',
}

export const COLUMN_LEVELS: Record<string, string> = {
  'place.1.label': 'Corsia',
  'place.2.label': 'Livello',
  'place.3.label': 'Posizione',
  'place.4.label': 'Scomparto',
}
